var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreatsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5153",
    "data-name": "Group 5153",
    transform: "translate(-1010 -1365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    transform: "translate(1013 1368)",
    fill: "#e52f77",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 30.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(1005.914 1310.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15055",
    "data-name": "Path 15055",
    d: "M28.11,74.271a.515.515,0,0,1-.095,1.026,7.949,7.949,0,0,0-7.96,4.6.513.513,0,0,1-.931-.431,8.963,8.963,0,0,1,8.986-5.191Zm25.854,9.745a.515.515,0,0,1-.423-.94l1.82-.828a.511.511,0,0,1,.681.259.519.519,0,0,1-.259.681ZM52.5,82.7a.517.517,0,1,1-1-.259l.354-1.328a.517.517,0,1,1,1,.259Zm1.63,3.786a.518.518,0,0,1,.354-.974l1.82.664a.518.518,0,1,1-.354.974Zm-2.234,1.087a.517.517,0,0,1,1.035,0V89.63a.517.517,0,0,1-1.035,0ZM49.643,87.1a.511.511,0,0,1,.707-.19.526.526,0,0,1,.19.707l-.974,1.69a.511.511,0,0,1-.707.19.518.518,0,0,1-.19-.707ZM27.885,94.528l-.492-3.941-.009-.129V88.474a1.077,1.077,0,0,1,1.087-1.061h1.2a1.075,1.075,0,0,1,1.078,1.061v1.983l-.009.129-.483,3.941a1.088,1.088,0,0,1-1.078.94,1.185,1.185,0,0,1-.923-.267A1.032,1.032,0,0,1,27.885,94.528Zm.535-4.062.5,3.95c.017.009.3.035.3-.017l.483-3.932-.009-2a.066.066,0,0,0-.043-.017h-1.2l-.043.026c.009.526-.052,1.544.009,1.992Zm1.294,0ZM27.48,98.624v-.992a1.077,1.077,0,0,1,1.087-1.061h1.026a1.075,1.075,0,0,1,1.078,1.061v.992a1.075,1.075,0,0,1-1.078,1.061H28.567A1.077,1.077,0,0,1,27.48,98.624Zm1.035-.992.009,1.009a.066.066,0,0,0,.043.017h1.026l.043-.026-.009-1.009a.066.066,0,0,0-.043-.017H28.558Zm3.518-12.573,3.725,6.459a11.373,11.373,0,0,0,2.725-10.529.522.522,0,0,1,.241-.569l1.052-.612L36.837,74.7l-1.138.664a.52.52,0,0,1-.621-.052,11.36,11.36,0,1,0-13.746,18l4.76-8.253A3.425,3.425,0,0,1,32.033,85.059ZM36.3,92.441,39.1,97.287a3.421,3.421,0,0,1-2.967,5.14H22a3.42,3.42,0,0,1-2.967-5.14L20.823,94.2a12.389,12.389,0,1,1,14.66-19.9l.845-.483a1.526,1.526,0,0,1,.543-2.1l1.88-1.087a1.52,1.52,0,0,1,2.1.586L42.5,74.09a4.242,4.242,0,0,1,6.235.267,4.175,4.175,0,0,1,.6,3.424c-.06.293-.121.535-.172.776a5.516,5.516,0,0,0-.034,3.648,4.136,4.136,0,0,0,3.277,2.346.516.516,0,0,1-.112,1.026,5.159,5.159,0,0,1-4.1-2.932,6.333,6.333,0,0,1-.034-4.329c.06-.276.129-.543.172-.742.793-3.889-3.553-4.631-5.286-2.553l1.871,3.242a1.52,1.52,0,0,1-.586,2.1l-1.854,1.069a1.527,1.527,0,0,1-2.087-.561l-.095-.164-.724.414a12.425,12.425,0,0,1-.216,6.088A12.228,12.228,0,0,1,36.3,92.441ZM38.2,97.8,31.136,85.568a2.392,2.392,0,0,0-4.148,0L19.926,97.8A2.393,2.393,0,0,0,22,101.4H36.13a2.388,2.388,0,0,0,2.07-3.6Zm3.794-22.542c-.009-.017-.017-.026-.026-.043l-2.009-3.493a.5.5,0,0,0-.69-.207l-1.88,1.087a.494.494,0,0,0-.181.673l4.079,7.071a.494.494,0,0,0,.673.181l1.9-1.1a.5.5,0,0,0,.172-.638Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreatsIcon);
export default __webpack_public_path__ + "static/media/threats-icon.b5e3fa37adb3111bd855bf66dd81fbc9.svg";
export { ForwardRef as ReactComponent };